import { render, staticRenderFns } from "./ViewDesignContent.vue?vue&type=template&id=918b2f46"
import script from "./ViewDesignContent.vue?vue&type=script&lang=js"
export * from "./ViewDesignContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports